var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTripbillfine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 73,
    viewBox: "0 0 88 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.3946 32.6683C92.1859 55.7905 68.742 28.0154 44.1305 41.9015C19.5191 55.7876 7.07439 76.8039 1.28313 53.6816C-4.50814 30.5594 9.84997 7.11114 33.3528 1.30847C56.8557 -4.4942 80.6033 9.54607 86.3946 32.6683Z",
    fill: "#EFEFEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0042 27.2324V56.9767C59.0042 59.4661 56.9861 61.4842 54.4967 61.4842H23.5075C21.0181 61.4842 19 59.4661 19 56.9767V15.5075C19 13.0181 21.0181 11 23.5075 11H42.7994C43.3118 11 43.8121 11.1163 44.2651 11.3342C44.606 11.4982 58.5338 25.4663 58.6993 25.8292C58.8983 26.2656 59.0042 26.7435 59.0042 27.2324Z",
    fill: "#F9F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0043 27.2327V29.2149H47.2486C43.7046 29.2149 40.8209 26.3278 40.8209 22.7804V11H42.7997C43.2892 11 43.7681 11.1064 44.2052 11.3064C44.5689 11.4728 58.5416 25.4775 58.7077 25.8473C58.9014 26.2788 59.0043 26.7504 59.0043 27.2327Z",
    fill: "#EBEBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8882 61.4842H23.5075C21.0182 61.4842 19 59.466 19 56.9767V15.5075C19 13.0182 21.0182 11 23.5075 11H26.8882C24.3989 11 22.3806 13.0182 22.3806 15.5075V56.9767C22.3806 59.466 24.3989 61.4842 26.8882 61.4842Z",
    fill: "#EBEBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4087 27.9052H25.4692C25.0024 27.9052 24.624 27.5268 24.624 27.06C24.624 26.5933 25.0024 26.2148 25.4692 26.2148H39.4087C39.8754 26.2148 40.2538 26.5933 40.2538 27.06C40.2538 27.5268 39.8754 27.9052 39.4087 27.9052Z",
    fill: "#777897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4087 48.1884H25.4692C25.0024 48.1884 24.624 47.81 24.624 47.3432C24.624 46.8765 25.0024 46.498 25.4692 46.498H39.4087C39.8754 46.498 40.2538 46.8765 40.2538 47.3432C40.2538 47.81 39.8754 48.1884 39.4087 48.1884Z",
    fill: "#777897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.486 34.6669H25.2438C24.7771 34.6669 24.3987 34.2885 24.3987 33.8217C24.3987 33.355 24.7771 32.9766 25.2438 32.9766H50.486C50.9527 32.9766 51.3311 33.355 51.3311 33.8217C51.3311 34.2885 50.9527 34.6669 50.486 34.6669Z",
    fill: "#777897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7011 25.8363H47.2486C45.5662 25.8363 44.2015 24.4683 44.2015 22.7825V11.3086C44.5666 11.4731 44.9036 11.7053 45.1921 11.9949L58.0171 24.8469C58.3044 25.1354 58.5366 25.4712 58.7011 25.8363Z",
    fill: "#777897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8516 41.4266H25.2438C24.7771 41.4266 24.3987 41.0484 24.3987 40.5815C24.3987 40.1146 24.7771 39.7363 25.2438 39.7363H44.8516C45.3183 39.7363 45.6967 40.1146 45.6967 40.5815C45.6967 41.0484 45.3183 41.4266 44.8516 41.4266Z",
    fill: "#777897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9069 65.5253L55.0181 56.7906L57.8952 53.9902L66.5643 60.8635C68.556 62.3556 68.3945 64.3162 66.8753 65.8367C65.3563 67.3572 63.3975 67.5189 61.9069 65.5253Z",
    fill: "#F69F94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1994 56.6102L57.661 60.1407L55.0184 56.7905L57.8954 53.9902L61.1994 56.6102Z",
    fill: "#F16D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9627 51.0731L52.1617 60.8535L43.7483 52.4503L53.5493 42.6699L61.9627 51.0731Z",
    fill: "#F69F94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5472 63.0356L52.5465 63.0363C51.7132 63.8679 50.4976 64.0036 49.8309 63.3393L41.2537 54.7775C40.5867 54.1128 40.7218 52.8991 41.5556 52.067L41.5563 52.0663C42.3896 51.2347 43.6052 51.099 44.2718 51.7633L52.8491 60.3251C53.5162 60.9897 53.3809 62.2035 52.5472 63.0356Z",
    fill: "#F16D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1194 51.4529L64.1201 51.4523C64.9509 50.6181 65.0865 49.4014 64.4229 48.7341L55.8692 40.1487C55.2052 39.4811 53.9926 39.6164 53.1613 40.451L53.1606 40.4516C52.3298 41.2858 52.1942 42.5025 52.8578 43.1698L61.4115 51.7552C62.0755 52.4228 63.288 52.2875 64.1194 51.4529Z",
    fill: "#F16D5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 13,
    y: 5,
    width: 61.037,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripbillfine);
export default __webpack_public_path__ + "static/media/tripbillfine.a785ecdc7b0f5c97162c151c552861ee.svg";
export { ForwardRef as ReactComponent };